/**
* @license Apache-2.0
*
* Copyright (c) 2022 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Evaluate the quantile function for a studentized range distribution.
*
* @module @stdlib/stats/base/dists/studentized-range/quantile
*
* @example
* import quantile from '@stdlib/stats/base/dists/studentized-range/quantile';
*
* var y = quantile( 0.5, 3.0, 2.0 );
* // returns ~1.908
*
* y = quantile( 0.1, 3.0, 4.0 );
* // returns ~0.627
*
* var myquantile = quantile.factory( 3.0, 3.0 );
*
* y = myquantile( 0.5 );
* // returns ~1.791
*
* y = myquantile( 0.8 );
* // returns ~3.245
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-nonenumerable-read-only-property';
import main from './main.js';
import factory from './factory.js';


// MAIN //

setReadOnly( main, 'factory', factory );


// EXPORTS //

export default main;
